import React, {} from "react";
import {Link, useLocation} from 'react-router-dom';
import classNames from "classnames";
import {observer} from "mobx-react-lite"
import menuStore from "common/menu/store/MenuStore";
import SessionInfo from "../../publish/layout/SessionInfo";
import userStore from "common/user/store/UserStore";
import MenuInfo from "common/menu/model/MenuInfo";
import AuthMenuLink from "../../components/link";
import logo from 'assets/img/logo/logo_blk_new.svg'; // [M.20240709] 수정

const HeaderSecondMenu = observer(({menuList}: { menuList?: MenuInfo[]; }) => {
    return (
        <ul className='d2'>
            {menuList?.map(item => (
                <li key={item.menuId} className={classNames({active: item.active})}>
                    <AuthMenuLink menuId={item.menuId} isNav={true} />
                </li>
            ))}
        </ul>
    )
});

const HeaderFirstMenu = observer(({menuList}: { menuList?: MenuInfo[]; }) => {
    return (
        <ul>{menuList?.map(item => (
            <li key={item.menuId} className={classNames('d1', {active: item.active})}>
                <AuthMenuLink menuId={item.menuId} isNav={true}><span>{item.menuNm}</span></AuthMenuLink>
                <ul className='d2'>
                    <HeaderSecondMenu
                        key={item.menuId}
                        menuList={item.children}
                    />
                </ul>
            </li>
        ))}</ul>
    )
})

function LayoutHeader() {
    const [hidden, setHidden] = React.useState(true);
    const location = useLocation();
    React.useEffect(() => {
        if (!menuStore.menuList || menuStore.menuList.length == 0 || menuStore.menuKnd == "ADMIN") {
            menuStore.readAllList("MAIN");
        }
    }, []);

    React.useEffect(() => {
        if (!menuStore.currentMenu) {
            menuStore.resetLocation(location.pathname);
        }
    }, [menuStore.menuList, location.pathname]);

    React.useEffect(() => {
        window.scrollTo(0,0)
    }, [location]);

    return (
        <>
            <div className='fww-util'>
                <ul>
                    {userStore.authenticated ? (
                        <>
                            <li>
                                <SessionInfo userStore={userStore} isAdmin={false}/>
                            </li>
                            <li>
                                <Link to="#" className="logout" onClick={() => {
                                    userStore.logout(false);
                                }}>로그아웃</Link>
                            </li>
                            <li>
                                <Link to="/main/usr_1000/usr_1500" className="mypage">마이페이지</Link>
                            </li>
                            {userStore.canAdminAccess() &&
                                <li>
                                    <Link to="/admin" className="home">관리자페이지</Link>
                                </li>
                            }
                        </>
                    ) : (
                        <>
                            <li><Link to="/main/usr_1000/usr_1300" className="login">로그인</Link></li>
                            <li><Link to="/main/usr_1000/usr_1200" className="join">회원가입</Link></li>
                        </>
                    )}
                </ul>
            </div>
            <header className={classNames('fww-header', 'usr', {active: !hidden})}>
                <div className='left-area'>
                    <Link to="/main" className='logo'>
                        <img src={logo} alt="대·중소기업 상생협력기금 종합시스템"/>
                    </Link>
                </div>
                <div className='right-area'>
                    <nav
                        className='fww-gnb'
                        onMouseEnter={() => setHidden(false)}
                        onMouseLeave={() => setHidden(true)}
                    >
                        <HeaderFirstMenu menuList={menuStore.menuTree}/>
                    </nav>

                </div>
            </header>
        </>
    );
}

export default observer(LayoutHeader);